<template>
    <div id="app">
        <div v-if="!loading" class="d-md-flex application">
            <main class="column-left">
                <CompanyDetails/>
                <div class="d-flex h-auto justify-content-center align-items-center flex-column order-complete">
                    <slot />
                </div>
                <small class="credits">
                    <img src="/images/hih_logo.svg" alt="">
                    is een initiatief van
                    <a
                        target="_blank"
                        href="https://www.23g.nl?source=haume-cuisine"
                        rel="nofollow noreferrer noopener"
                        class="mx-1 text-decoration-none"
                        style="color: var(--baseColor);"
                    >
                        23G
                    </a>
                    in samenwerking met
                    <a
                        target="_blank"
                        href="https://www.heerlijk.nl?source=haume-cuisine"
                        rel="nofollow noreferrer noopener"
                        class="ml-1 text-decoration-none"
                        style="color: var(--baseColor);"
                    >
                        heerlijk.nl
                    </a>
                </small>
            </main>
            <aside class="column-right">
                <ShoppingCart/>
            </aside>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import CheckoutForm from '@/components/checkout/Form';
    import CompanyDetails from '@/components/company/Details';
    import ProductList from '@/components/products/List';
    import ShoppingCart from '@/components/products/Cart';

    export default {
        components: {
            CheckoutForm,
            ProductList,
            ShoppingCart,
            CompanyDetails,
        },
        computed: {
            ...mapState({
                checkout: state => state.cart.checkout,
                loading: state => state.products.checkout,
            }),
        },
        mounted() {
            this.$store.dispatch('cart/emptyCart');
            this.$store.dispatch('cart/unsetCheckout');
        },
        async created() {
            await this.$store.dispatch('products/getRestaurant');
        },
    };
</script>

<style lang="scss">
    .order-complete {
        padding: 30px;
        color: $silver-chalice;
        background: #fff;
        border-radius: 6px;

        h1 {
            margin-bottom: 20px;
            font-size: 30px;
            color: $mine-shaft;
        }

        .ordernumber {
            margin: 15px 0;
            font-size: 18px;
            font-weight: bold;
            color: $mine-shaft;
        }

        .user-info {
            margin: 32px 0 0;

            h2 {
                margin-bottom: 16px;
                font-size: 20px;
                color: $mine-shaft;
            }

            strong {
                display: block;
                margin-bottom: 4px;
                color: $mine-shaft;
            }
        }
    }
</style>
